"use client";

import { type UseContactSalesFormV2Return } from "../hooks/useContactSalesFormV2";
import { fieldConfig } from "../shared/constants";

export function Step1({ form, validators, t }: Pick<UseContactSalesFormV2Return, "form" | "validators" | "t">) {
  return (
    <>
      <form.AppField
        name={fieldConfig.website.name}
        validators={{
          onMount: validators.website,
          onChange: validators.website,
        }}
      >
        {field => (
          <field.Input
            name={fieldConfig.website.name}
            label={t("fields.website.label")}
            placeholder={t("fields.website.placeholder")}
            required={fieldConfig.website.required}
          />
        )}
      </form.AppField>
      <form.AppField
        name={fieldConfig.email.name}
        validators={{
          onMount: validators.email,
          onChange: validators.email,
        }}
      >
        {field => (
          <field.Input
            name={fieldConfig.email.name}
            label={t("fields.email.label")}
            placeholder={t("fields.email.placeholder")}
            type={fieldConfig.email.type}
            required={fieldConfig.email.required}
          />
        )}
      </form.AppField>
    </>
  );
}
